import Svg from "@/components/Svg";

const CLIP_ID = "clip0_patient_added_icon";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

const PatientAddedIconPaths = ({ color }) => (
  <g clipPath={`url(#${CLIP_ID})`}>
    <path
      d="M14.8891 1.97239C17.2362 1.97239 19.1438 3.88278 19.1438 6.22992C19.1438 8.57706 17.2334 10.4875 14.8891 10.4875C12.5448 10.4875 10.6316 8.57706 10.6316 6.22992C10.6316 3.88278 12.542 1.97239 14.8891 1.97239ZM14.8891 0C11.4487 0 8.65918 2.78952 8.65918 6.22992C8.65918 9.67033 11.4487 12.4598 14.8891 12.4598C18.3295 12.4598 21.1162 9.67033 21.1162 6.22992C21.1162 2.78952 18.3295 0 14.8891 0Z"
      fill={color}
    />
    <path
      d="M29.011 26.3453H0.0112708L0.00281769 25.3675C0.00281769 25.3337 0 25.3027 0 25.2717C0 18.7037 6.72866 13.3613 15.0014 13.3613C17.2668 13.3613 19.4421 13.7502 21.468 14.5194C21.978 14.7138 22.2344 15.283 22.04 15.7902C21.8456 16.3002 21.2764 16.5566 20.7692 16.3622C18.9659 15.6803 17.0245 15.3337 15.0014 15.3337C8.21358 15.3337 2.62327 19.3123 2.02592 24.3729H27.9769C27.9036 23.7558 27.7543 23.1415 27.5317 22.547C27.3401 22.037 27.5993 21.4678 28.1093 21.2762C28.6193 21.0846 29.1885 21.3439 29.3801 21.8539C29.7943 22.9584 30.0056 24.108 30.0056 25.2717C30.0056 25.3027 30.0056 25.3365 30.0056 25.3675L29.9972 26.3453H29.0194H29.011Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.4925 17.0435L23.8884 21.6476C23.5756 21.9604 23.0572 21.9604 22.7331 21.6476L20.4367 19.3512C20.124 19.0384 20.124 18.52 20.4367 18.1959C20.7495 17.8832 21.2679 17.8832 21.592 18.1959L23.322 19.926L27.3513 15.8967C27.6641 15.5839 28.1826 15.5839 28.5066 15.8967C28.8081 16.2094 28.8081 16.7279 28.4953 17.0407L28.4925 17.0435Z"
      fill={color}
    />
  </g>
);

export default function PatientAddedIcon({ size = 30, withCircle = false, color = "#1A1A1A" }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 30 27";
  const iconTransform = withCircle ? "translate(25 26.8273)" : "";
  const width = size;
  const height = withCircle ? size : (size * 27) / 30;

  return (
    <Svg
      as="svg"
      width={width}
      height={height}
      minWidth={width}
      minHeight={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <PatientAddedIconPaths color={color} />
      </g>
      <defs>
        <clipPath id={CLIP_ID}>
          <rect width="30" height="26.3454" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
